"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChasedByBearsAbilityHandler = exports.ChasedByBearsActorAbilityFactory = exports.ChasedByBearsAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Random_1 = require("../../utils/Random");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const Duration_1 = require("../../core/Duration");
const core_2 = require("../../core/effects/core");
class ChasedByBearsAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ChasedByBears;
        this.__typeName = "ChasedByBears";
    }
}
exports.ChasedByBearsAbilityArgs = ChasedByBearsAbilityArgs;
let ChasedByBearsActorAbilityFactory = class ChasedByBearsActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ChasedByBears", "AllEnemies", 4);
    }
};
ChasedByBearsActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ChasedByBears")
], ChasedByBearsActorAbilityFactory);
exports.ChasedByBearsActorAbilityFactory = ChasedByBearsActorAbilityFactory;
let ChasedByBearsAbilityHandler = class ChasedByBearsAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const enemies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        container.applyProjectileAttacksWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "ranged",
            attackerId: ability.invokerId,
            projectiles: Array((0, Random_1.random)(5, 10)).fill(0)
                .map(() => ({
                creatorId: ability.invokerId,
                targetId: (0, Random_1.randomElement)(enemies),
                jitter: (0, Random_1.random)(25, 225),
                type: "Bear",
                path: "arc",
                end: "feet",
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Physical", 10)
                ]
            })),
            onHit: (sequence, _attack, _damages, { targetId }) => {
                sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet"), "CannonBallExplosion"));
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new core_2.BleedingEffectArgs("Power", 10)
                });
            }
        });
    }
};
ChasedByBearsAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ChasedByBears)
], ChasedByBearsAbilityHandler);
exports.ChasedByBearsAbilityHandler = ChasedByBearsAbilityHandler;
